"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return LinksColumn;
    }
});
const _ = require("~/models/");
const _LinkToAnotherRecordColumn = /*#__PURE__*/ _interop_require_default(require("~/models/LinkToAnotherRecordColumn"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let LinksColumn = class LinksColumn extends _LinkToAnotherRecordColumn.default {
    get fk_relation_column_id() {
        return this.fk_column_id;
    }
    get fk_rollup_column_id() {
        if (this.type === 'hm') {
            return this.fk_child_column_id;
        } else if (this.type === 'mm') {
            return this.fk_parent_column_id;
        } else if (this.type === 'bt') {
            return this.fk_parent_column_id;
        } else if (this.type === 'oo') {
            return this.fk_parent_column_id;
        }
        // Default fallback for any other types (mo, om, etc.)
        return this.fk_parent_column_id;
    }
    async getRelationColumn(context, ncMeta = _Noco.default.ncMeta) {
        return await _.Column.get(context, {
            colId: this.fk_column_id
        }, ncMeta);
    }
    async getRollupColumn(context, ncMeta = _Noco.default.ncMeta) {
        return await _.Column.get(context, {
            colId: this.fk_rollup_column_id
        }, ncMeta);
    }
    static async read(context, columnId, ncMeta = _Noco.default.ncMeta) {
        const colData = await super.read(context, columnId, ncMeta);
        return colData && new LinksColumn(colData);
    }
    static async insert(context, data, ncMeta = _Noco.default.ncMeta) {
        const colData = await super.insert(context, data, ncMeta);
        return colData && new LinksColumn(colData);
    }
    constructor(...args){
        super(...args), this.rollup_function = 'count';
    }
};
